var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"btn btn_next",attrs:{"type":"submit"},domProps:{"value":_vm.translations.move}})}
var staticRenderFns = []

export { render, staticRenderFns }